import type { FC } from 'react';
import { useWebsocketLineFull } from '@mwl/core-lib';
import { Markets } from '@/components/Markets/Markets';
import { base } from '@/constants';
import type { LineRowOutrightProps } from './LineRowOutright.types';
import styles from './LineRowOutright.module.scss';
export const LineRowOutright: FC<LineRowOutrightProps> = ({
  line: initialLine,
  className
}) => {
  const line = useWebsocketLineFull(initialLine, base.NAME_PROJECT);
  return <div className={cn(styles.root, className)} data-sentry-component="LineRowOutright" data-sentry-source-file="LineRowOutright.tsx">
      <Markets lineId={line.id} lineStage="OUTRIGHT" markets={line.markets} isPaused={line.status === 'PAUSED'} category={line.category.title} championships={line.championship.title} matchId={line.championshipId} sportCategory={line?.sport?.title} isFinished={false} activeFilter={null} variant="OUTRIGHT" data-sentry-element="Markets" data-sentry-source-file="LineRowOutright.tsx" />
    </div>;
};